import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import {
  FaUserGraduate, FaFemale, FaTractor,
  FaLaptopCode, FaTools, FaHeartbeat, FaUsers
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import "./VisionSection.css";

export default function VisionSection() {
  const { t } = useTranslation();

  const [slidesToShow, setSlidesToShow] = useState(4);

  useEffect(() => {
const handleResize = () => {
  const width = window.innerWidth;

  if (width <= 767) {
    setSlidesToShow(1);        // Mobile
  } else if (width <= 1023) {
    setSlidesToShow(2);        // Tablet
  } else if (width === 1024) {
    setSlidesToShow(3);        // Laptop 1024px
  } else {
    setSlidesToShow(4);        // Desktop
  }
};

    handleResize(); // run on mount
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 600,
    slidesToShow,
    slidesToScroll: 1
  };

  const cards = [
    { icon: <FaUserGraduate className="visionSlider_icon" />, title: t("vision_youth_title"), desc: t("vision_youth_desc") },
    { icon: <FaFemale className="visionSlider_icon" />, title: t("vision_women_title"), desc: t("vision_women_desc") },
    { icon: <FaTractor className="visionSlider_icon" />, title: t("vision_agri_title"), desc: t("vision_agri_desc") },
    { icon: <FaLaptopCode className="visionSlider_icon" />, title: t("vision_it_title"), desc: t("vision_it_desc") },
    { icon: <FaTools className="visionSlider_icon" />, title: t("vision_skill_title"), desc: t("vision_skill_desc") },
    { icon: <FaHeartbeat className="visionSlider_icon" />, title: t("vision_health_title"), desc: t("vision_health_desc") },
    { icon: <FaUsers className="visionSlider_icon" />, title: t("vision_comm_title"), desc: t("vision_comm_desc") }
  ];

  return (
    <section className="visionSlider_wrapper">
      <div className="visionSlider_container">

        <h2 className="visionSlider_title">
          {t("vision_main_title")}
          <span className="vs_highlightRed">{t("vision_red_highlight")}</span>
        </h2>

        <Slider {...settings} className="visionSlider_box">
          {cards.map((item, index) => (
            <div className="visionSlider_card" key={index}>
              <div className="visionSlider_iconBox">{item.icon}</div>
              <h3 className="visionSlider_cardTitle">{item.title}</h3>
              <p className="visionSlider_cardDesc">{item.desc}</p>

              <a href="/event">
                <button className="visionSlider_btn">
                  {t("vision_button")}
                </button>
              </a>
            </div>
          ))}
        </Slider>

      </div>
    </section>
  );
}
